import { NODE_ENV } from "@shared/env";
import url from "@shared/utils/urls/url";
import { useCallback, useMemo } from "react";
import { RemoveAllSeatsModalSharedProps } from "./RemoveAllSeatsModal.props";

export function useRemoveAllSeatsModal(props: RemoveAllSeatsModalSharedProps) {
  const { onClose, resolve, eventData } = props;

  const cancel = useCallback(() => onClose(null), [onClose]);
  const removeAllSeats = useCallback(() => resolve(true), [resolve]);

  const seatingHref = useMemo(() => {
    const isPreview = NODE_ENV === "preview";

    if (isPreview) {
      // frontend_details_url handles both membership and event routes
      return [eventData?.frontend_details_url ?? url(), "seating"].join("");
    }

    // if object is a membership, add /m/ to route
    if (eventData?.membership_levels) {
      return url(["m", eventData?.slug, "seating"]);
    }

    // standard event route
    return url([eventData?.slug, "seating"]);
  }, [eventData]);

  return {
    cancel,
    removeAllSeats,
    seatingHref,
  };
}
